var f;!function(f){f[f.Effect=1]="Effect",f[f.LayoutEffect=2]="LayoutEffect"}(f||(f={}));export{f as ReactEffectType};
//# sourceMappingURL=types.js.map
